import { PopupManager } from 'element-ui/src/utils/popup'

const ERROR_EDIT_CLASS_NAME = 'kye-edit-table-error-statu-edit'
let currentErrorClassName = null
// 获取滚动的父级元素
export function getScrollParent(element) {
  let style = window.getComputedStyle(element)
  const excludeStaticParent = style.position === 'absolute'
  const overflowRegex = /(auto|scroll)/
  if (style.position === 'fixed') return document.body
  let parent = element.parentElement
  while (parent) {
    style = window.getComputedStyle(parent)
    if (excludeStaticParent && style.position === 'static') {
      parent = parent.parentElement
      continue
    }
    const overflowStyle = style.overflow + style.overflowY + style.overflowX
    if (overflowRegex.test(overflowStyle)) return parent
    parent = parent.parentElement
  }
  return document.body
}

/**
 *
 * @export 滚动到指定的dom位置
 * @param {*} element
 */
export function scrollParentToElement(element) {
  const parent = getScrollParent(element)
  if (!parent.classList.contains('el-table__body-wrapper')) {
    return
  }
  // 将不在浏览器窗口的可见区域内的元素滚动到浏览器窗口的可见区域。如果该元素已经在浏览器窗口的可见区域内，则不会发生滚动。此方法是标准的
  element.scrollIntoViewIfNeeded()
}

/**
 *
 * @desc 获取气泡框的参照物dom
 * @param {*} rowIndex
 * @param {*} columnIndex
 * @param {*} refs
 * @return {*}
 */
// function getCurrentValidateRef(rowIndex, columnIndex, refs) {
//   const ref = setEditFormRefStr(rowIndex, columnIndex)
//   // 循环的组件 取值时就是数组
//   const [refInstance] = refs[ref] || []
//   if (!refInstance) {
//     return null
//   }
//   let reference = refInstance.$el.parentElement.parentElement || refInstance.$el.parentElement
//   if (reference) {
//     const node = reference.querySelector('.tableContent')
//     if (node) {
//       reference = node
//     }
//   }
//   return reference
// }

function getCurrentValidateRef (rowIndex, columnIndex, refs) {
  const ref = setEditFormRefStr(rowIndex, columnIndex)
  // 循环的组件 取值时就是数组
  const [refInstance] = refs[ref] || []
  if (!refInstance) {
    return null
  }
  const reference = refInstance.$el.parentElement.parentElement || refInstance.$el.parentElement
  return reference
}
/**
 *
 * @desc 获取ref的格式 和template的对应
 * @param {*} rowIndex
 * @param {*} columnIndex
 * @return {*}
 */
function setEditFormRefStr(rowIndex, columnIndex) {
  return `row_${rowIndex}${columnIndex}`
}

/**
 *
 * @desc 给错误的单元格dom添加红框样式
 * @param {*} rowIndex
 * @param {*} columnIndex
 * @param {*} type
 * @param {*} refs
 * @return {*}
 */
function setCurrentValidateRefErrorClass(reference, type) {
  if (!reference) {
    return
  }
  const className = ERROR_EDIT_CLASS_NAME
  currentErrorClassName = className
  if (type === 'add') {
    // 给参照物添加红框
    if (!reference.classList.contains(className)) {
      reference.classList.add(className)
    }
  } else {
    if (reference.classList.contains(className)) {
      reference.classList.remove(className)
    }
  }
  return reference
}

/**
 *
 * @desc 获取column中rule的规则，区分自定义和非自定义，以及他们的数组和对象情况
 * @param {*} rule
 * @return {*}
 */
function getErrorRule(rule) {
  if (!rule) {
    return {}
  }
  const iter = r => {
    return r.customRule || r
  }
  if (Array.isArray(rule)) {
    let val = null
    for (let i = 0; i < rule.length; i++) {
      const r = rule[i]
      val = iter(r)
      if (val) {
        break
      }
    }
    return val || {}
  } else {
    return iter(rule) || {}
  }
}

/**
 *
 * @desc 过滤rules中的trigger，防止async-validator库出现校验错误, 隐藏的列需要排除掉规则，如果存在规则
 * @param {*} rules
 * @return {*}
 */
function filterTriggerOfRule(rules, visibleColumnMap) {
  const descriptor = {}
  const ruleKeys = Object.keys(rules || {})
  if (ruleKeys.length > 0) {
    ruleKeys.forEach(key => {
      const rule = rules[key]
      if (Array.isArray(rule)) {
        descriptor[key] = rule.map(ele => {
          const { trigger, ...restRule } = ele
          if (trigger) {
            return {
              ...restRule
            }
          } else {
            return ele
          }
        })
      } else {
        const { trigger } = rule
        descriptor[key] = { ...rule }
        if (trigger) {
          delete descriptor[key]['trigger']
        }
      }
    })
  }
  visibleColumnMap &&
    Object.keys(descriptor).forEach(k => {
      if (!visibleColumnMap.has(k)) {
        delete descriptor[k]
      }
    })
  return descriptor
}

/**
 *
 * @desc 获取当前错误的单元格列的信息以及索引
 * @param {*} triggerKey
 * @param {*} fields
 * @param {*} columnConfig
 * @return {*}
 */
function getCurrentErrorColumnConfig(triggerKey, fields, columnConfig, visibleColumnMap) {
  const key = triggerKey || Object.keys(fields)[0] || ''
  const columnIndex = visibleColumnMap ? visibleColumnMap.get(key) : columnConfig.findIndex(col => col.key === key)
  const column = columnConfig[columnIndex]
  return {
    column,
    columnIndex
  }
}

export function createPopover(popoverReferenceIOInstance, vm) {
  /**  气泡相关  **/
  // 设置气泡的数据
  const setPopoverAttrs = (reference, content, popoverProps = {}) => {
    vm.$refs.editTablePopoverRef.referenceElm = reference
    vm.popperContent = (h = vm.$createElement) => {
      return (<div domPropsInnerHTML={content}></div>)
    }
    vm.popoverProps = popoverProps
    // 重新计算气泡
    vm.$refs.editTablePopoverRef.createPopper()
  }
  // 隐藏气泡
  const hiddenPoppver = () => {
    if (vm.$refs.editTablePopoverRef) {
      vm.$refs.editTablePopoverRef.showPopper = false
    }
  }
  // 显示气泡
  const visiblePoppver = () => {
    if (vm.$refs.editTablePopoverRef) {
      vm.$refs.editTablePopoverRef.showPopper = true
      if (PopupManager) {
        vm.$nextTick(() => {
          vm.$refs.editTablePopoverRef.popperElm.style.zIndex = PopupManager.nextZIndex()
        })
      }
    }
  }
  // 更新气泡位置
  const updatePoppver = () => {
    if (vm.$refs.editTablePopoverRef) {
      vm.$refs.editTablePopoverRef.updatePopper()
    }
  }
  // 在执行删除行操作时的气泡逻辑
  const popoverChangeOfDelRow = () => {
    // 数据变化之后，如果校验行没有了，则需要隐藏气泡
    const data = vm.tData.data
    const { currentRowError_uuid } = vm
    if (!data.length) {
      hiddenPoppver()
    } else {
      if (!data.map(row => row._uuid).includes(currentRowError_uuid)) {
        hiddenPoppver()
      } else {
        vm.$nextTick(() => {
          updatePoppver()
        })
      }
    }
  }
  // 在执行新增行操作时的气泡逻辑
  const popoverChangeOfAddRow = () => {
    vm.$nextTick(() => {
      updatePoppver()
    })
  }

  /**  气泡参照物监听其是否在可视区域相关逻辑（非可视区域隐藏）  **/
  // 销毁监听气泡参照物监听的实例
  const destroyPopoverReferenceObserver = () => {
    if (popoverReferenceIOInstance) {
      popoverReferenceIOInstance.disconnect()
      popoverReferenceIOInstance = null
    }
  }
  // 开启监听气泡参照物的是否出现在可视区域
  const popoverReferenceObserver = () => {
    // 要观察的元素
    const targetElement = vm.$el.querySelector('.' + currentErrorClassName)
    // 有错误的元素证明一定要显示
    if (!targetElement) {
      hiddenPoppver()
      return
    }
    destroyPopoverReferenceObserver()
    const fixedDom = vm.$el.querySelector('.el-table__fixed')
    const options = {
      threshold: 0.5 // 可视区域的阈值，0表示只要有一点进入可视区域则会 entry.isIntersecting等于true反之false 1表示整体显示在可视区域
    }
    if (fixedDom) {
      const fixedLeft = fixedDom.offsetWidth
      if (fixedLeft) {
        Object.assign(options, {
          root: vm.$el,
          rootMargin: `0px 0px 0px ${-fixedLeft}px`
        })
      }
    }
    popoverReferenceIOInstance = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 元素在可视区域内内
          visiblePoppver()
          updatePoppver()
        } else {
          hiddenPoppver()
        }
      })
    }, options)
    // 开始观察
    popoverReferenceIOInstance.observe(targetElement)
  }
  // 滚轮事件句柄
  const wheelScrollEvent = () => {
    popoverReferenceObserver()
  }
  // 监听滚轮事件，并在事件中开启气泡参照物的监听，为什么不具体到DOM？因为不清楚哪一层dom产生的滚轮事件
  const handleWheelScrollEvent = () => {
    vm.$el.addEventListener('wheel', wheelScrollEvent)
    const parent = getScrollParent(vm.$el)
    parent && parent.addEventListener('scroll', updatePoppver)
  }
  // 销毁滚轮事件
  const removeWheelScrollListener = () => {
    vm.$el.removeEventListener('wheel', wheelScrollEvent)
    const parent = getScrollParent(vm.$el)
    parent && parent.removeEventListener('scroll', updatePoppver)
    destroyPopoverReferenceObserver()
  }

  /**  单元格校验时气泡相关逻辑  **/
  // 移除未通过校验的单元格的红色边框
  const removeValidateRefErrorClass = () => {
    const dom = vm.$el.querySelector('.' + currentErrorClassName)
    if (dom && dom.classList.contains(currentErrorClassName)) {
      dom.classList.remove(currentErrorClassName)
    }
  }
  // 在未通过校验的单元格生产有错误信息展示的气泡
  const createPopoverInstanceOfValidateError = ({
    triggerKey,
    fields,
    rowIndex,
    errorMsg,
    columnConfig,
    $refs,
    visibleColumnMap
  }) => {
    if (!fields) {
      return false
    }
    const { column, columnIndex } = getCurrentErrorColumnConfig(triggerKey, fields, columnConfig, visibleColumnMap)

    const reference = getCurrentValidateRef(rowIndex, columnIndex, $refs)
    if (!reference) {
      console.error('ERP-ERROR：kye-edit-table tips reference is not element')
      return
    }

    // 气泡属性以及reference（参照物）配置
    const { message } = getErrorRule(column.rule)
    let content = message
    if (!content) {
      // 都没有则使用错误的校验信息
      content = errorMsg
    }
    if (content) {
      setCurrentValidateRefErrorClass(reference, 'add')
      scrollParentToElement(reference)
      setPopoverAttrs(reference, content, column.popoverProps)
      vm.$nextTick(() => {
        visiblePoppver()
      })
    }
  }
  const validateNexOfTrigger = ({ i, fields }) => {
    // 自动校验下一行数据在有trigger的场景下 需要主动开启 没有trigger不自动触发
    if (vm.autoValidateNextRowOfTrigger) {
      vm.$set(vm.currentRowErrorStack, i, fields)
    }
    vm.currentRowErrorIndex = i
    vm.currentRowError_uuid = vm.tData.data[i]._uuid
  }
  // 获取校验规则
  const getScheamRules = () => filterTriggerOfRule(vm.rules, vm.visibleColumnMap)
  // 在表格数据校验失败时的逻辑
  const validateErrorManager = ({ i, fields, errors, triggerKey }) => {
    const { columnConfig, $el, $refs } = vm
    removeValidateRefErrorClass($el)
    // 如果是triggerKey触发的，但是校验已经通过了，则关闭气泡和红框
    const errorKeys = Object.keys(fields)
    if (triggerKey && errorKeys.length && !errorKeys.includes(triggerKey)) {
      hiddenPoppver()
    } else {
      // 原有提示逻辑，暂不去除
      const key = triggerKey || Object.keys(fields)[0] || ''
      const errorMsg = fields[key] && fields[key][0] ? fields[key][0].message : null
      // 如果没找到错误的信息，则使用的历史的提示逻辑
      if (!errorMsg) {
        const key = errorKeys[0] || ''
        const columnIndex = vm.visibleColumnMap ? vm.visibleColumnMap.get(key) : -1
        const col = columnIndex > -1 ? columnConfig[columnIndex] : columnConfig.find(col => col.key === key)
        let label = col ? col.label : ''
        vm.$message.error(`${label}-第${vm.tData.data[i]._tIndex + 1}行：${errors[0].message}`)
        return
      }
      createPopoverInstanceOfValidateError({
        triggerKey,
        fields,
        rowIndex: i,
        errorMsg,
        columnConfig,
        $refs,
        visibleColumnMap: vm.visibleColumnMap
      })
      vm.$nextTick(() => {
        popoverReferenceObserver()
      })
    }
  }
  // 在数据校验成功的逻辑，移除气泡实例以及红色边框
  const removePopperOfValidateSuccess = () => {
    hiddenPoppver()
    removeValidateRefErrorClass()
  }

  /**  单元格校验时自动触发校验项的相关逻辑  **/
  // 自动触发校验事件发射器
  const doingTriggerEmitter = (index, column, name) => {
    // 需要用户主动开启trigger。影响面太大
    if (!vm.$props.useRuleTrigger) {
      return
    }
    const { key } = column
    if (column.rule) {
      const iter = rule => {
        if (!rule) {
          return
        }
        const { trigger } = rule
        if (Array.isArray(trigger)) {
          if (trigger.includes(name)) {
            vm.validate(index, key)
          }
        } else {
          if (trigger === name) {
            vm.validate(index, key)
          }
        }
      }
      // 数组的情况，校验分
      if (Array.isArray(column.rule)) {
        let rule = null
        for (let i = 0; i < column.rule.length; i++) {
          const r = column.rule[i]
          if (r) {
            const { trigger } = r
            if (trigger) {
              rule = r
            }
          }
          if (rule) {
            break
          }
        }
        iter(rule)
      } else {
        iter(column.rule)
      }
    }
  }
  // 自动执行下一行数据校验触发器
  const doingNextValidateOfTrigger = (currentRowErrorStack = {}) => {
    const length = vm.tData.data.length - 1
    const currentRowErrorIndex = vm.currentRowErrorIndex
    if (
      !currentRowErrorStack[currentRowErrorIndex] &&
      currentRowErrorIndex !== length &&
      length > currentRowErrorIndex
    ) {
      // 满足条件，开始执行下一行的校验
      vm.validate(currentRowErrorIndex + 1)
    }
  }

  /**  watch监听执行相关逻辑  **/
  const watchManager = () => {
    // 自动执行下一行校验的逻辑
    vm.$watch(
      'currentRowErrorStack',
      val => {
        doingNextValidateOfTrigger(val)
      },
      {
        deep: true
      }
    )
  }

  const eventManager = (...args) => {
    const [eventName, ...restArgs] = Array.from(args)
    const eventsMap = {
      inputBlur: ({ index, row, column, data }) => {
        if (!column.change) {
          const prow = vm.tData.data[index]
          prow[column.key] = data
        }
        doingTriggerEmitter(index, column, 'blur')
      },
      uploadSuccess: ({ index, row, column }) => {
        doingTriggerEmitter(index, column, 'change')
      },
      areaRemoteChange: ({ index, row, column, data }) => {
        const prow = vm.tData.data[index]
        prow[column.key] = data
        doingTriggerEmitter(index, column, 'change')
      },
      elInput: ({ index, row, column, data }) => {
        const prow = vm.tData.data[index]
        prow[column.key] = data
        doingTriggerEmitter(index, column, 'input')
      },
      selectChange: ({ index, row, column }) => {
        doingTriggerEmitter(index, column, 'change')
      },
      searchTipsSelect: ({ index, row, column }) => {
        doingTriggerEmitter(index, column, 'change')
      },
      searchTipsClose: ({ index, row, column }) => {
        doingTriggerEmitter(index, column, 'tagClose')
      },
      inputChange: ({ index, row, column }) => {
        doingTriggerEmitter(index, column, 'change')
      },
      datetimeChange: ({ index, row, column }) => {
        doingTriggerEmitter(index, column, 'change')
      }
    }
    return eventsMap[eventName](...restArgs)
  }

  const triggerEventManager = (...args) => {
    try {
      return eventManager(...args)
    } catch (error) {
      console.log('event-no-exist', error)
    }
  }

  // 销毁气泡实例和监听等操作
  const destroyd = () => {
    removeWheelScrollListener()
    destroyPopoverReferenceObserver()
    hiddenPoppver()
  }

  const lifeCycleHooks = vm => {
    vm.$on('hook:mounted', () => {
      handleWheelScrollEvent()
      watchManager()
    })
    vm.$on('hook:activated', () => {
      popoverReferenceObserver()
      // console.log('-------hook:activated')
    })
    vm.$on('hook:deactivated', () => {
      hiddenPoppver()
      destroyPopoverReferenceObserver()
      // console.log('-------hook:deactivated')
    })
    vm.$on('hook:beforeDestroy', () => {
      destroyd()
      // console.log('-------hook:beforeDestroy')
    })
  }

  return {
    lifeCycleHooks,
    // handleWheelScrollEvent,
    validateErrorManager,
    getScheamRules,
    removePopperOfValidateSuccess,
    popoverChangeOfDelRow,
    popoverChangeOfAddRow,
    hiddenPoppver,
    destroyd,
    triggerEventManager,
    validateNexOfTrigger
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-edit-table/popover/index.js